module.exports = __webpack_public_path__ + "img/3fe14fc.jpg";